import axios from '../utils/axios';
import { baseURL } from '../utils/axios';

export const getBanks = async () => {
  const res = await axios.get(`/banks`);
  return res.data;
};

export const saveBankDetails = async (id, token, data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  };
  const response = await axios.post(
    `${baseURL}/schools/${id}/bank-account`,
    data,
    config
  );
  return response.data;
};

export const updateBankDetails = async (id, token, data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  };
  const response = await axios.put(
    `${baseURL}/schools/${id}/bank-account`,
    data,
    config
  );
  return response.data;
};

export const resolveBankDetails = async (id, token, data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  };
  const response = await axios.post(
    `${baseURL}/banks/${id}/account/resolve`,
    data,
    config
  );
  return response.data;
};

export const getBankDetails = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  };
  const response = await axios.get(
    `${baseURL}/schools/${id}/bank-account`,

    config
  );
  return response.data;
};

export const setSettlement = async (id, token, data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  };
  const response = await axios.post(
    `${baseURL}/schools/${id}/settlement-ratio`,
    data,
    config
  );
  return response.data;
};

export const getSettlementRatio = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  };
  const response = await axios.get(
    `${baseURL}/schools/${id}/settlement-ratio`,
    config
  );
  return response.data;
};
